module.exports = {

  // production
  // apiEndpoint: "https://api.bharatselfdrive.com/api/v1",
  // BaseUrl: "https://api.bharatselfdrive.com",

  // // staging
  apiEndpoint: "https://testingapi.bharatselfdrive.com/api/v1",
  BaseUrl: "https://testingapi.bharatselfdrive.com",


  // development - use proxy path to avoid CORS
  // BaseUrl: "http://localhost:4000",
  // apiEndpoint: "http://localhost:4000/api/v1",

  GOOGLE_MAP_KEY: "AIzaSyB8YbkwvUiwIUxKek_hMCPXBu9jEROJwL4",
  MAP_AUTO_REFESH: 45,
  referralEndpoint: "https://referral.bharatselfdrive.com/api/v1",
};
